import React from 'react'
import { observable, action, runInAction, toJS } from 'mobx'
import Api from '@api/xi_feng/newCustomer'
import {
  PROPERTY_WITH_WEDDING_OBJ,
  PROPERTY_WITH_WEDDING
} from '../../constant'
import { Icon as LegacyIcon } from '@ant-design/compatible'
import { message, Modal } from 'hljd'
import moment from 'moment'
import { hashHistory } from 'react-router'
import QuestionDrawerStore from '../QuestionDrawer/store'
import Style from './style.module.less'
import { isExperienceStore } from '@util'
import isEmpty from 'lodash/isEmpty'

class Store {
  @observable phoneData = {}
  @observable budgetList = []
  @observable detailData = {}
  @observable showBudgetList = false
  @observable sourceList = []
  shouldSearchPhone = true

  constructor() {
    this.questionDrawerStore = new QuestionDrawerStore(this)
  }

  @action
  setStoreData = (data = []) => {
    runInAction(() => {
      data.forEach(item => {
        this[item.type] = item.value
      })
    })
  }

  @action
  searchPhone = async phone => {
    if (!this.shouldSearchPhone) {
      this.shouldSearchPhone = true
      return
    }
    const { data, success } = await Api.searchPhone({ phone })
    if (!success) {
      return
    }
    if (data && data.id) {
      Modal.confirm({
        icon: <LegacyIcon type={null} />,
        title: `提示:手机号 ${phone} 已存在`,
        className: `${Style['exit-user-box']}`,
        cancelText: '修改本次录入号码',
        okText: '跳转详情',
        width: 440,
        content: (
          <div className={Style['exit-user']}>
            <img
              src={
                data.user
                  ? data.user.avatar
                  : '//qnm.hunliji.com/o_1d1g0i1o84t319ks1fch68v10k89.png'
              }
            />
            <div>
              <i
                className={`icon iconfont sex-icon ${
                  data.gender == 1
                    ? 'icon-nan'
                    : data.gender == 2
                      ? 'icon-nv'
                      : ''
                }`}
              />
              <span className={Style.nowrap}>{data.user_name}</span>
              <div>
                <span className="label" style={{ marginLeft: 0 }}>
                  婚期：
                </span>
                <span className={Style.nowrap}>{data.weddingday}</span>
                <span className="label">负责人：</span>
                <span>
                  {data.merchant_support &&
                    data.merchant_support.length &&
                    data.merchant_support.map(item => item.nick).join(',')}
                </span>
              </div>
            </div>
          </div>
        ),
        onOk() {
          hashHistory.push(`localMerchant/newCustomer/detail/${data.id}`)
        },
        onCancel() {
          const allInputDOM = document.querySelectorAll(
            '#add-customer-drawer-body input'
          )
          allInputDOM.forEach(dom => {
            const id = dom.getAttribute('id')
            if (id !== 'user_phone') {
              dom.blur()
            } else {
              setTimeout(() => {
                dom.focus()
              }, 200)
            }
          })
          // document.getElementById('user_phone').focus()
        }
      })
      return true
    }
    return false
  }

  @action
  getCustomerDetail = async id => {
    const { data, success } = await Api.getCustomerDetail({ id })
    if (!success) {
      return
    }
    let city_id = []
    if (data.full_address_info) {
      if (data.full_address_info.province) {
        city_id.push(data.full_address_info.province)
      }
      if (data.full_address_info.city) {
        city_id.push(data.full_address_info.city)
      }
      if (data.full_address_info.district) {
        city_id.push(data.full_address_info.district)
      }
    }
    data.city_id = city_id
    data.demand_list.forEach(item => {
      const _survey_answer = item.survey_answer.map(val => {
        return {
          question_id: val.question_id,
          content: val.answer
        }
      })
      this.questionDrawerStore.getSurvey(
        _survey_answer,
        item.survey.survey_id,
        item.property_id
      )
    })

    runInAction(() => {
      this.detailData = data
      this.budgetList =
        data.demand_list && data.demand_list.length
          ? data.demand_list
          : PROPERTY_WITH_WEDDING
      this.showBudgetList =
        data.demand_list && data.demand_list.length ? true : false
      this.sourceList = [{ id: data.source, title: data.source_name }]
    })

    //this.getSourceList() //获取来源列表，展示是使用，新增时是常量
  }

  @action
  onBudgetItemChange = value => {
    const budgetList = value.map(item => {
      const idx = this.budgetList.findIndex(budget => {
        return budget.property_id == item
      })
      if (idx < 0) {
        return {
          property_name: PROPERTY_WITH_WEDDING_OBJ[item],
          budget_money: 0,
          remark: '',
          property_id: item
        }
      } else {
        return this.budgetList[idx]
      }
    })
    this.budgetList = budgetList
  }

  @action
  delBudgetItem = index => {
    let budgetList = this.budgetList.filter((item, idx) => idx !== index)
    this.budgetList = budgetList
  }

  @action
  getBudget = async (value, cb) => {
    const { data, success } = await Api.getBudget(value)
    if (!success) {
      return
    }
    runInAction(() => {
      this.budgetList.forEach(budget => {
        const _budget = data.find(item => {
          return item.property_id == budget.property_id
        })
        budget.budget_money = _budget ? _budget.budget_money : 0
      })
    })
    data.forEach(item => {
      let v = {}
      v[`budget-${item.property_id}`] = item.budget_money
      cb && cb(v)
    })
  }

  @action
  reset = type => {
    runInAction(() => {
      this.shouldSearchPhone = false
      this.showBudgetList = false
      if (type == 'new') {
        this.budgetList = PROPERTY_WITH_WEDDING
      }
    })
  }

  @action
  updateSurveyInfo = (answers, questions, property_id) => {
    const _budgetList = this.budgetList.map(item => {
      if (item.id == property_id || item.property_id == property_id) {
        item.survey_answer = answers
        item.questions = questions
      }
      return item
    })
    runInAction(() => {
      this.budgetList = _budgetList
    })
    this.handleOk && this.handleOk(true)
  }

  @action
  getSubmitInfo = (name, value) => {
    runInAction(() => {
      this[name] = value
    })
  }

  @action
  handleOk = async not_close_modal => {
    const { type, form } = this.props
    const fieldValue = form.getFieldsValue()
    const {
      showBudgetList,
      questionDrawerStore: { survey = [] }
    } = this

    if (!fieldValue.user_name) {
      return message.error('请填写姓名')
    }
    if (type === 'new' && !fieldValue.source) {
      return message.error('请选择来源')
    }

    if (isExperienceStore() && isEmpty(fieldValue.shop_area_id)) {
      return message.error('请填写用户所在城市，这将影响客户归属和派单')
    }

    if (type === 'new' && fieldValue.user_phone) {
      const user_phont_is_exit = await this.searchPhone(fieldValue.user_phone)
      if (user_phont_is_exit) {
        return
      }
    }
    let demand_list = []
    let budget_money_sum = 0
    fieldValue.budgetType.forEach(item => {
      const budget_money = fieldValue['budget-' + item]
        ? Number(fieldValue['budget-' + item])
        : 0
      if (showBudgetList) {
        demand_list.push({
          property_name: PROPERTY_WITH_WEDDING_OBJ['' + item],
          budget_money: budget_money,
          remark: fieldValue['des-' + item] || '',
          property_id: '' + item
        })
      }
      budget_money_sum += budget_money
    })

    let _survey = []
    survey.forEach(item => {
      const { survey_id, answers } = item
      if (answers.length) {
        _survey.push({
          survey_id,
          answers
        })
      }
    })

    const value = {
      user_name: fieldValue.user_name,
      user_phone: fieldValue.user_phone,
      gender: fieldValue.gender,
      user_wechat: fieldValue.user_wechat,
      mate_name: fieldValue.mate_name,
      mate_phone: fieldValue.mate_phone,
      mate_wechat: fieldValue.mate_wechat,
      budget_money_sum,
      source: fieldValue.source,
      weddingday: fieldValue.weddingday
        ? moment(fieldValue.weddingday).format('YYYY-MM-DD')
        : '',
      demand_list: JSON.stringify(demand_list),
      shop_area_id:
        fieldValue.shop_area_id && fieldValue.shop_area_id.length
          ? [...fieldValue.shop_area_id].reverse()[0]
          : '',
      survey: JSON.stringify(toJS(_survey))
    }
    value.modify_fields = JSON.stringify(value)
    this.props.onOk && this.props.onOk(value, not_close_modal)
  }

  // getSourceList = async () => {
  //   const { success, data } = await Api.sourceList()
  //   if (success) {
  //     runInAction(() => {
  //       this.sourceList = data.map(item => {
  //         const { id, name } = item
  //         return {
  //           id: `${id}`,
  //           title: name
  //         }
  //       })
  //     })
  //   }
  // }
}
export default Store
